import { ProfileDetailData } from "@/mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.reducers";
import { UserEntity } from "@/mk2/schemas";
import { canManageBlogs, isAuthenticatedAs } from "@/mk/bazaar/common/userUtils";

export function checkIfmoreAboutMeHasContent(
    isMobile: boolean,
    profileDetailData: ProfileDetailData,
    requestUser: UserEntity,
    requestUserPermissions: string[],
) {
    const {
        followers,
        following,
        memberOfGroups,
        pregnancyDaysCounter,
        pregnancyWeekNumber,
        user,
        userAboutMeText,
        userStrollers,
        userVendorData,
    } = profileDetailData;

    const isOwner = isAuthenticatedAs(requestUser, user);
    const isBlogsAdmin = canManageBlogs(requestUserPermissions);

    // keep synced with conditions in MoreAboutMe.tsx
    return !!(
        isOwner ||
        isBlogsAdmin ||
        (isMobile && !!userAboutMeText && userAboutMeText.trim()) ||
        (pregnancyDaysCounter && pregnancyWeekNumber) ||
        userVendorData ||
        (userStrollers &&
            userStrollers.length > 0 &&
            (isOwner || isBlogsAdmin) &&
            following.count) ||
        followers.count > 0 ||
        memberOfGroups.count > 0
    );
}
